import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ModalCompAdvance } from "../../Ui/ModalComp";
import { TextInputComp, FormikTextAreaComp } from "../..";
import InvestorPortalActionButton from "./InvestorPortalActionButton";

const schema = Yup.object({
  quantity: Yup.number().min(0).required("Quantity is required"),
  note: Yup.string(),
});

export default function AdminStockAdjustmentModal({ show, product, onClose, onSubmit }) {
  if (!product) return null;

  const body = (
    <>
      <p className="text-muted small mb-3">
        Current stock: <strong>{product.stockQuantity}</strong> · Threshold: {product.lowStockThreshold}
      </p>
      <Formik
        initialValues={{ quantity: product.stockQuantity, note: "" }}
        validationSchema={schema}
        onSubmit={async (values) => {
          await onSubmit({ quantity: Number(values.quantity), note: values.note });
          onClose();
        }}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form>
            <TextInputComp label="New quantity" name="quantity" type="number" />
            <FormikTextAreaComp label="Note (optional)" name="note" rows={3} />
            <div className="d-flex gap-2 justify-content-end mt-3">
              <InvestorPortalActionButton btnText="Cancel" type="button" variant="ghost" fullWidth={false} onClick={onClose} />
              <InvestorPortalActionButton btnText="Save adjustment" type="submit" variant="primary" fullWidth={false} disabled={isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return (
    <ModalCompAdvance
      show={show}
      handleClose={onClose}
      modalTitle="Adjust stock"
      close
      size="md"
      centered
      arrayComp={[{ component: body }]}
    />
  );
}
